import { PricingBucketRow } from "./steps/PricingBucketsStep";

export const isWithinRange = (row: PricingBucketRow): boolean =>
  row.value.value >= row.floor.value && row.value.value <= row.max;

// The offending rows are seeded from the partner's own defaults, so an operator
// can meet this gate on a deal they have not touched a single field of. Name the
// buckets and their verdict rather than leaving them to find the red rows.
export const describeOutOfRange = (rows: PricingBucketRow[]): string =>
  rows
    .map(
      (row) =>
        `${row.label} (${
          row.value.value > row.max ? "above max" : "below floor"
        })`
    )
    .join(", ");
